import { PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

// Backend `action` values for the image runs the assistant drives. Both image providers
// declare the same set - see Generator::Providers::Flux::Schemas::Catalog and
// Generator::Providers::NanoBanana::Schemas::Catalog.
export const IMAGE_ACTION = {
  TEXT_TO_IMAGE: 'text-to-image',
  SIMILAR_IMAGE: 'similar-image',
  IMAGE_EDIT: 'image-edit',
  MULTI_IMAGE_EDIT: 'multi-image-edit',
  MASKED_EDIT: 'masked-edit',
}

// Every image model, by provider and action. New runs do not pick from this table - they
// send the action and let the backend rank the providers - but a run that already exists
// only records the model it used, so this is what maps one back to its action.
//
// The two providers are interchangeable per action: their input_image rules are identical
// (similar-image takes 1, multi-image-edit 2-8, masked-edit exactly 2) and they differ
// only in output params the assistant never sends - flux takes
// width/height/safety_tolerance/output_format, nano-banana aspect_ratio/image_size.
const MODEL_ID_BY_PROVIDER = {
  [PROVIDER.FLUX]: {
    [IMAGE_ACTION.TEXT_TO_IMAGE]: 'flux-text-to-image-pro',
    [IMAGE_ACTION.SIMILAR_IMAGE]: 'flux-similar-image-pro',
    [IMAGE_ACTION.IMAGE_EDIT]: 'flux-image-edit-pro',
    [IMAGE_ACTION.MULTI_IMAGE_EDIT]: 'flux-multi-image-edit-pro',
    [IMAGE_ACTION.MASKED_EDIT]: 'flux-masked-edit-pro',
  },
  [PROVIDER.NANO_BANANA]: {
    [IMAGE_ACTION.TEXT_TO_IMAGE]: 'nano-banana-text-to-image-lite',
    [IMAGE_ACTION.SIMILAR_IMAGE]: 'nano-banana-similar-image-lite',
    [IMAGE_ACTION.IMAGE_EDIT]: 'nano-banana-image-edit-lite',
    [IMAGE_ACTION.MULTI_IMAGE_EDIT]: 'nano-banana-multi-image-edit-lite',
    [IMAGE_ACTION.MASKED_EDIT]: 'nano-banana-masked-edit-lite',
  },
}

// Reverse lookup across every provider, so a run is classified by what it did rather than
// by which provider ran it - the backend is free to answer the same action with either.
const ACTION_BY_MODEL_ID = Object.fromEntries(
  Object.values(MODEL_ID_BY_PROVIDER).flatMap(
    actions => Object.entries(actions).map(([action, modelId]) => [modelId, action]),
  ),
)

/**
 * The image action a stored run performed, whichever provider produced it.
 * @param {string|undefined} providerModelId
 * @returns {string|undefined} One of IMAGE_ACTION, or undefined for an unknown model
 */
export const imageActionOf = providerModelId => ACTION_BY_MODEL_ID[providerModelId]
